import Breadcrumb from '@components/v2/ui/Breadcrumb/Breadcrumb';
import IconButton from '@components/v2/ui/IconButton/IconButton';
import { Stack } from '@mui/material';
import { ArrowLeft } from 'lucide-react';
import LangEnum from '../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../modules/translation/TranslationContext';
import { BreadcrumbItem } from '../../../ui/Breadcrumb/breadcrumb.types';

interface ScreenHeaderBreadcrumbProps {
  items: BreadcrumbItem[];
  hasGoBackButton?: boolean;
  onGoBack?: () => void;
}

export const ScreenHeaderBreadcrumb = ({
  items,
  hasGoBackButton,
  onGoBack,
}: ScreenHeaderBreadcrumbProps) => {
  const { translate } = useTranslation();

  const breadcrumb = <Breadcrumb items={items} />;

  if (!hasGoBackButton || !onGoBack) {
    return breadcrumb;
  }

  return (
    <Stack direction="row" sx={{ alignItems: 'center', gap: 0.5, minWidth: 0 }}>
      <IconButton
        icon={ArrowLeft}
        ariaLabel={translate(LangEnum.GLOBAL_GO_BACK)}
        onClick={onGoBack}
      />
      {breadcrumb}
    </Stack>
  );
};
